/* eslint-disable @typescript-eslint/ban-ts-comment */
import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';
import './sliderShopify.css';
import ShopifyPricing, { IShopifyPricingProps } from './ShopifyPricing';

interface ISliderShopifyProps extends IShopifyPricingProps {
    sliderElement: HTMLElement;
    sliderLabels: string[];
}

class SliderShopify {
    private shopifyPricing: ShopifyPricing;

    constructor(data: ISliderShopifyProps) {
        const { sliderLabels } = data;
        this.shopifyPricing = new ShopifyPricing(data);

        const format = {
            to: function (value: number) {
                return sliderLabels[value];
            },
            from: function (value: string) {
                return value;
            },
        };

        const slider = noUiSlider.create(data.sliderElement, {
            start: this.shopifyPricing.value,
            step: 1,
            connect: true,
            range: {
                min: 0,
                max: sliderLabels.length - 1,
            },
            pips: {
                //@ts-ignore
                mode: 'steps',
                //@ts-ignore
                format,
            },
            //@ts-ignore
            format,
        });
        const onChange = this.shopifyPricing.onChange;

        slider.on('update', function (value) {
            const selected = sliderLabels.findIndex((el) => el === value[0]);
            if (typeof selected === 'number') onChange({ selected });
        });
    }
}

export default SliderShopify;
